var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.playOnClick)?_c('div',{ref:"lavContainer",style:(_vm.style),on:{"click":function($event){return _vm.replay()}}}):_c('div',{ref:"lavContainer",style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }